import { useTranslation } from 'react-i18next';

import { ImportAnkiForm, ImportTableForm } from '@/features/deck-import';

import styles from './ImportDeckPage.module.css';

/** Brings decks in from Anki or from a table, into the user's own space only. */
export function ImportDeckPage(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <h1>{t('import.title')}</h1>
      <section className={styles.box} aria-labelledby="import-anki">
        <h2 id="import-anki">{t('import.ankiTitle')}</h2>
        <p className={styles.muted}>{t('import.ankiExplain')}</p>
        <ImportAnkiForm />
      </section>
      <section className={styles.box} aria-labelledby="import-table">
        <h2 id="import-table">{t('import.tableTitle')}</h2>
        <p className={styles.muted}>{t('import.tableExplain')}</p>
        <ImportTableForm />
      </section>
    </div>
  );
}
